import { isFreeUser, isTeamUser } from '../../services/entity/user/user-service';

const settingsPath = '/settings/';

/**
 * Get general navigation menu
 */
export const getGeneralNavigationMenu = (user) => {
  return [
    {
      name: 'DEMO',
      icon: 'camera',
      href: 'demo/live',
      isVisible: false,
      isActive: isMenuItemValid('demo/live'),
      isEnabled: true,
    },
    {
      name: 'HISTORY',
      icon: 'menu_book',
      href: 'dashboard',
      isVisible: true,
      isActive: isMenuItemValid('history') || isHomePage(),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'DASHBOARD',
      icon: 'dashboard',
      href: 'dashboard/data',
      isVisible: true,
      isActive: isMenuItemValid('history/data'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'RECORDER',
      icon: 'camera',
      href: 'recorder',
      isVisible: false,
      isActive: isMenuItemValid('recorder'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'SAVOIR-FAIRE',
      icon: 'camera',
      href: 'recorder/get-stream',
      isVisible: false,
      isActive: isMenuItemValid('recorder'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'SETUP',
      icon: 'source',
      href: 'setup',
      isVisible: false,
      isActive: isMenuItemValid('setup'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'LIVE VIEW',
      icon: 'build',
      href: 'interface/live',
      isVisible: true,
      isActive: isMenuItemValid('interface'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'ERGONOMICS',
      icon: 'directions_walk',
      href: 'ergonomics',
      isVisible: false,
      isActive: isMenuItemValid('ergonomics'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
    {
      name: 'GAMMES',
      icon: 'source',
      href: 'processes',
      isVisible: false,
      isActive: isMenuItemValid('processes'),
      isEnabled: true,
    },
    {
      name: 'GALERIE',
      icon: 'camera',
      href: 'gallery',
      isVisible: false,
      isActive: isMenuItemValid('gallery'),
      isEnabled: true,
    },
    {
      name: 'GALERIE',
      icon: 'camera',
      href: 'recorder-gallery',
      isVisible: false,
      isActive: isMenuItemValid('recorder-gallery'),
      isEnabled: true,
    },
    {
      name: 'CATALOGUE',
      icon: 'menu_book',
      href: 'shorts',
      isVisible: false,
      isActive: isMenuItemValid('shorts'),
      isEnabled: true,
    },
    {
      name: 'ADMIN',
      icon: 'storage',
      href: 'backoffice',
      isVisible: false,
      isActive: isMenuItemValid('backoffice'),
      isEnabled: !isFreeUser(user) || isTeamUser(user),
    },
  ];
};

/**
 * Get heading navigation menu for settings' pages
 */
export const getSettingsNavigationMenu = () => {
  return [
    {
      name: 'Profile',
      icon: 'person',
      href: settingsPath + 'profile',
      current: isMenuItemValid(settingsPath + 'profile'),
    },
  ];
};

/**
 * Check if a menu item corresponds to the active page
 */
export const isMenuItemValid = (path) => {
  return window.location.pathname.includes(path);
};

/**
 * Check if the active page is the home page
 */
export const isHomePage = () => {
  return window.location.pathname === '/';
};
